<template>
  <div class="sf-flash-manager__container" data-testid="sf-flash-manager">
    <SfBannerSystem
      v-for="({ variant, text, autoCloseAfter }, index) in bannerList"
      :key="`${text}-${variant}`"
      :auto-close-after="autoCloseAfter"
      :variant="variant"
      :show-close="true"
      @close="close(index)"
    >
      {{ text }}
    </SfBannerSystem>
  </div>
</template>

<script lang="ts" setup>
import { type SilverfinFlash } from '@app/types'

import { ref, onMounted, onBeforeUnmount } from 'vue'

import type { MessageTypeToVariantType } from './constants';
import { messageTypeToVariant } from './constants'
import SfBannerSystem from '@app/shared/vue/components/sf-banner/sf-banner-system.vue'


defineOptions({
  name: 'SfFlashManager',
})

type Banner = {
  variant: MessageTypeToVariantType
  text: string
  autoCloseAfter?: number
}

const bannerList = ref<Banner[]>([])

const addBanner: SilverfinFlash['addFlash'] = (type, text, autoCloseAfter) => {
  const variant = messageTypeToVariant[type]

  const alreadyExists = bannerList.value.some(
    (banner) => banner.variant === variant && banner.text === text
  )

  if (!alreadyExists) {
    bannerList.value.push({ variant, text, autoCloseAfter })
  }
}

const addBanners: SilverfinFlash['setFlashMessages'] = (banners) => {
  banners.forEach((banner) => addBanner(banner[0], banner[1], banner[2]))
}

const close = (index: number) => {
  bannerList.value.splice(index, 1)
}

const clear = () => {
  bannerList.value = []
}

onMounted(() => {
  window.eventHub.$on('sf-flash-manager:add-banner', addBanners)
  window.eventHub.$on('sf-flash-manager:add-banners', addBanners)
  window.eventHub.$on('sf-flash-manager:clear-banners', clear)
})

onBeforeUnmount(() => {
  window.eventHub.$off('sf-flash-manager:add-banner', addBanners)
  window.eventHub.$off('sf-flash-manager:add-banners', addBanners)
  window.eventHub.$off('sf-flash-manager:clear-banners', clear)
})
</script>
